import { Errors, paths } from 'config'

// There's no one to reauthenticate after a sign-out, e.g. in another tab, so the
// sign-in starts over, showing that the session has ended
export const SIGNED_OUT_REAUTHENTICATION_REDIRECT = {
  pathname: paths.signIn,
  state: { error: Errors.SessionEnded },
}
